<template>
  <v-dialog v-model="dialog" persistent="persistent" max-width="500">
    <v-card grid-list-md="grid-list-md">
      <v-toolbar dark="dark" color="primary">
        <v-btn icon="icon" dark="dark" @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t('buttons.addFunds') }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <!-- <v-container grid-list-lg="grid-list-lg"> -->
        <v-layout row="row" wrap="wrap">
          <v-flex xs12="xs12" sm12="sm12">
            <v-text-field v-model="Wallet.refID" :label="$t('labels.refernceNumber')"></v-text-field>
          </v-flex>
          <v-flex xs12="xs12">
            <v-text-field class="right-input" :error-messages="AmountErrors" type="number" v-model="Wallet.amount"
              :label="$t('labels.amount')"></v-text-field>
          </v-flex>
        </v-layout>
        <!-- </v-container> -->
      </v-card-text>
      <v-card-actions>
        <v-checkbox v-model="Wallet.chargeStripe" :label="chargeLabel"></v-checkbox>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat="flat" @click="close()">Close</v-btn>
        <v-btn color="blue darken-1" dark="dark" @click="save()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import locationService from '../../Location/service.js'
import walletService from '../service'

const { validationMixin } = require('vuelidate')
const {
  required,
  numeric
} = require('vuelidate/lib/validators')

export default {
  props: {
    createDialog: {
      default: false
    },
  },
  name: 'create-wallet',
  data() {
    return {
      loading: false,
      dialog: false,
      stores: [],
      Wallet: {
        storeID: null,
        amount: null,
        refID: null,
        chargeStripe: true,
        crm: true,
      }
    }
  },
  mixins: [validationMixin],
  validations: {
    Wallet: {
      amount: {
        required,
        numeric
      },
    },
  },
  computed: {
    ...mapGetters('location', ['location']),
    chargeLabel() {
      let value = 'Without Charge Card'
      if (this.Wallet.chargeStripe) {
        value = 'Charge Card'
      }
      return value
    },
    AmountErrors() {
      const errors = []
      if (!this.$v.Wallet.amount.$dirty) return errors
      if (!this.$v.Wallet.amount.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Wallet.amount.numeric) errors.push(this.$t('validations.validAmount'))
      return errors
    },
  },
  watch: {
    createDialog(val) {
      this.dialog = val
      this.Wallet.storeID = this.location.storeID
    }
  },
  methods: {
    ...mapActions("location", ["setLocation"]),
    close() {
      this.$emit('close')
    },
    save() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        }).fire({
          type: 'error',
          title: this.$t('toastMessage.text.invalidFields')
        })
      } else {
        this.$Progress.start()
        walletService.addFund(this.Wallet)
          .then(() => {
            this.$toasted.success('Funds Added', {
              position: 'top-right',
              showHideTransition: 'slide',
              icon: 'check',
              duration: 2000,
            })
            this.$Progress.finish()
            this.$emit("save")
            this.setLocation(this.location.storeID);
            this.close()
          })
          .catch(() => {
            this.$toasted.error('Funds were not added', {
              position: 'top-right',
              showHideTransition: 'slide',
              icon: 'error',
              duration: 2000,
            })
            this.$Progress.fail()
          })
      }

    }
  }
}
</script>

<style scoped>

</style>
